import { createAction } from '@reduxjs/toolkit';
export const LOAD_NOTIFICATIONS= 'LOAD_NOTIFICATIONS';
export const loadNotificationsAction = createAction(LOAD_NOTIFICATIONS);